const Announcement = (props) => {
  const { title, description, link, priority } = props;

  let bgColor = priority === "Important" ? "is-warning" : "is-info";
  bgColor = priority === "Urgent" ? "is-danger" : bgColor;

  return (
    <div className={`mx-2 message is-small ${bgColor}`}>
      <div className="message-header">
        <p>{title}</p>
      </div>
      <div
        className="message-body"
        style={{ weight: "30%", height: "8rem", overflowY: "auto" }}
      >
        <p>{description}</p>
        <div className="is-flex is-justify-content-center is-align-items-center is-flex-wrap-wrap">
          <a
            href={link}
            className={`mt-2 button is-small ${bgColor}`}
            role="button"
            target="_self"
            rel="noopener noreferrer"
          >
            Check it out
          </a>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
